module.exports = __webpack_public_path__ + "static/media/the-university-of-sydney.8455ed19.png";